import * as $ from 'jquery';
import { CountdownTimer, TickEvent } from "./countdowntimer";

export class MemberSQTimer {
    isTimerDone: boolean;
    totalSeconds: number;
    securityQuestionID: number;
    $timerDisplay: JQuery;
    timer: CountdownTimer;

    constructor() {
        this.isTimerDone = true;
        this.totalSeconds = 0;
        this.securityQuestionID = 0;
        this.$timerDisplay = $('#counttimer');
    }

    startTimer(seconds: number, sqID: number) {
        this.isTimerDone = true;
        this.totalSeconds = seconds;
        this.securityQuestionID = sqID;
        const self = this;
        //alert(this.securityQuestionID)
        // start the timer!
        if (this.totalSeconds > 0) {
            this.timer = new CountdownTimer();
            this.timer.on("tick", (tevent) => self.tick(tevent));
            this.timer.on("expired", () => self.timerDone());
            this.isTimerDone = false;
            this.timer.startTimer(self.totalSeconds);
        }
    }

    timerDone() {
        //alert(self.securityQuestionID)
        var postFailUrl = "/SecurityQuestion/FailTimeout/" + this.securityQuestionID;
        $.post(postFailUrl, function (data) {
            window.location.href = "/SecurityQuestion/Fail";
        });
    }

    private tick(evt: TickEvent) {
        const formattedSeconds = CountdownTimer.getFormattedTime(evt.secondsLeft);
        this.$timerDisplay.text(formattedSeconds);
    }
}